import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  readEmail,
  toggleEmailDialog,
  replyToEmail,
  toggleMessageMenu,
} from 'actions/inbox'
import { readBlob } from 'actions/data'
import { withStyles, Grid, FormHelperText } from '@material-ui/core'
import { Reply } from '@material-ui/icons'
import conversationItemTypes from './conversationItemTypes'
import AvatarWithLabel from '../AvatarWithLabel'
import moment from 'moment'
// import contactLabel from 'utils/contactLabel'
import htmlToText from 'html-to-text'
import afinn from 'afinn-165'
import { words } from 'lodash'
import inboxItemLabels from 'utils/inboxItemLabels'
import { startCase } from 'lodash'
// import Link from 'utils/Link'
import { AttachFile } from '@material-ui/icons'
import textObjFn from 'utils/textObjFn'
const Handlebars = require('handlebars')
// const template = Handlebars.compile('')
// console.log(template({ name: 'Nils' }))

const styles = theme => ({
  threadItemContainer: {
    padding: '10px 20px 10px 60px',
    position: 'relative',
  },
  threadItem: {
    backgroundColor: '#f1f1f1',
    padding: '12px 16px 16px 62px',
    borderRadius: 13,
    position: 'relative',
    minHeight: 64,
  },
  avatar: {
    position: 'absolute',
    top: 0,
    left: '-51px',
  },
  iconContainer: {
    position: 'absolute',
    top: '50%',
    left: 14,
    transform: 'translate(0, -50%)',
    textAlign: 'center',
  },
  icon: {
    fill: '#c2c2c2',
    fontSize: 30,
  },
  iconLabel: {
    fontSize: 10,
    color: '#c2c2c2',
    marginTop: '-4px',
  },
  previewText: {
    marginTop: 25,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 195,
    cursor: 'pointer',
    content: '""',
    '&:hover': {
      backgroundColor: '#0000004a',
    },
    '&:before': {
      content: '""',
      width: '100%',
      height: '100%;   ',
      position: 'absolute',
      left: '0',
      top: '0',
      background: 'linear-gradient(transparent 145px, #f1f1f1)',
    },
  },
  replyButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: '#0000008A',
    fontSize: 12,
    cursor: 'pointer',
    borderRadius: 12,
    padding: '0 6px 0 2px',
    '&:hover': {
      backgroundColor: '#0000004a',
    },
  },
})

const Email = connect(
  (state, { email, contact }) => ({
    loaded: Boolean(state.inbox.emailsLoaded[email.full_email_uri]),
    content:
      state.inbox.emailsLoaded[email.full_email_uri] &&
      state.inbox.emailsLoaded[email.full_email_uri].content,
    businessName:
      state.AccountSettings.settings &&
      state.AccountSettings.settings.business_name,
    accountName:
      state.AccountSettings.settings && state.AccountSettings.settings.name,
    vastuser: state.data?.['account/user']?.[contact?.vastuser],
    preferences: state.data?.['account/preference']?.preferences,
    account: state.data?.account,
    assignedNumber: Object.values(state.data?.phonenumbers || {})?.find(
      numberObj => numberObj?.vast_user_name === contact?.vastuser,
    )?.phone_number,
    // AssignedUser: {
    //   username: contact?.vastuser,
    //   first_name: state.data?.['account/user']?.[contact?.vastuser],
    //   last_name: null,
    //   email: null,
    //   phone_number: null,
    // },
  }),
  dispatch =>
    bindActionCreators(
      { readEmail, toggleEmailDialog, replyToEmail, toggleMessageMenu },
      dispatch,
    ),
)(
  withStyles(styles)(
    ({
      email,
      idx,
      readEmail,
      toggleEmailDialog,
      classes,
      content,
      lastInThread,
      contact,
      businessName,
      loaded,
      newConversationItem,
      accountName,
      replyToEmail,
      vastuser,
      preferences,
      account,
      toggleMessageMenu,
      assignedNumber,
    }) => {
      let compiledText = email.preview_text
      let text = ''

      if (loaded && lastInThread && content) {
        if (content.text_body) {
          compiledText = content.text_body
        } else if (content.html_body) {
          compiledText = htmlToText.fromString(content.html_body)
        }
      }

      const textObj = textObjFn({
        contact,
        vastuser,
        preferences,
        account,
        assignedNumber,
      })

      try {
        compiledText = Handlebars.compile(compiledText || '')
        text = compiledText(textObj)
      } catch (error) {
        console.log(error)
      }

      const score = words(text).reduce((sum, word) => {
        sum += afinn[word] || 0
        return sum
      }, 0)

      return (
        <div
          style={{
            position: 'relative',
            paddingTop: 16,
            minHeight: 52,
            paddingBottom: 5,
          }}
        >
          <div className={classes.avatar}>
            <AvatarWithLabel
              type={email.direction === 'outbound' ? 'user' : 'contact'}
              contact={contact}
              label={inboxItemLabels({
                itemType: 'email',
                item: email,
                businessName,
                accountName,
                contact,
              })}
            />
          </div>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              fontSize: 14,
              width: '100%',
            }}
          >
            <div
              style={{
                width: lastInThread ? 'calc(100% - 65px)' : '100%',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              <span style={{ fontWeight: 'bold' }}>
                {inboxItemLabels({
                  itemType: 'email',
                  item: email,
                  businessName,
                  accountName,
                  contact,
                })}
              </span>
            </div>
            <div
              style={{ color: '#5f5f5f', marginTop: 3 /* marginLeft: 15 */ }}
            >
              {moment(email.timestamp).format('ddd, MMM D, YYYY h:mm A')}
            </div>
          </div>
          <div
            onClick={() => {
              if (email.full_email_uri && !loaded) {
                readEmail(email.full_email_uri).then(payload =>
                  toggleEmailDialog(email.full_email_uri, textObj),
                )
              } else if (loaded) {
                toggleEmailDialog(email.full_email_uri, textObj)
              }
            }}
            className={classes.previewText}
            style={
              newConversationItem ||
              (lastInThread && content && content.text_body)
                ? { whiteSpace: 'pre-wrap' }
                : { whiteSpace: 'nowrap' }
            }
          >
            {text}
          </div>
          {lastInThread && email.status && (
            <FormHelperText
              style={{ position: 'absolute', bottom: '-12px', right: 0 }}
            >
              <em>{startCase(email.status)}</em>
            </FormHelperText>
          )}
          {lastInThread && (
            <div
              className={classes.replyButton}
              onClick={() => {
                replyToEmail(email, contact)
                toggleMessageMenu(true)
              }}
            >
              <Reply
                style={{
                  marginRight: 2,
                  verticalAlign: 'middle',
                  marginTop: '-2px',
                }}
              />
              REPLY
            </div>
          )}
          {lastInThread && score > 0 ? (
            <span
              style={{
                color: 'green',
                position: 'absolute',
                right: 0,
                top: 19,
              }}
            >
              ☺
            </span>
          ) : lastInThread && score < 0 ? (
            <span
              style={{
                color: 'red',
                position: 'absolute',
                right: 0,
                top: 19,
              }}
            >
              ☹
            </span>
          ) : null}
        </div>
      )
    },
  ),
)

const EmailItem = ({
  classes,
  key,
  conversationItem,
  contact,
  readEmail,
  readBlob,
}) => {
  const Icon = conversationItemTypes[conversationItem.type].icon
  const subject = conversationItem =>
    conversationItem.thread &&
    conversationItem.thread.emails &&
    conversationItem.thread.emails[0] &&
    conversationItem.thread.emails[0].subject

  return (
    <div key={key} className={classes.threadItemContainer}>
      {subject(conversationItem) ? (
        <div
          style={{
            color: '#6d6d6d',
            fontSize: '14.5px',
            marginBottom: 3,
          }}
        >
          <b>SUBJECT:</b> {subject(conversationItem)}
        </div>
      ) : null}
      <div className={classes.iconContainer}>
        <Icon className={classes.icon} />
        <div className={classes.iconLabel}>
          {conversationItemTypes[conversationItem.type].label}
        </div>
      </div>
      <div className={classes.threadItem}>
        {/* <div className={classes.avatar}>
          <AvatarWithLabel contact={contact} />
        </div> */}
        <Grid
          justify="center"
          direction="column-reverse"
          container
          alignItems="flex-start"
          style={{
            fontSize: 14,
            minHeight: 52,
          }}
        >
          {conversationItem.thread && conversationItem.thread.emails
            ? conversationItem.thread.emails.map((email, idx) => (
                <Grid
                  key={`conversation${contact.id}emailThread${idx}${
                    email.timestamp || (idx + 1) * Math.random()
                  }`}
                  item
                  style={
                    idx === 0 /* conversationItem.thread.emails.length - 1 */
                      ? {
                          paddingTop: 5,
                          width: '100%',
                          // maxWidth: '48vw',
                        }
                      : idx ===
                        conversationItem.thread.emails.length - 1 /* 0 */
                      ? {
                          paddingBottom: 5,
                          borderBottom: '1px solid gray',
                          width: '100%',
                          // maxWidth: '48vw',
                        }
                      : {
                          paddingBottom: 5,
                          paddingTop: 5,
                          borderBottom: '1px solid gray',
                          width: '100%',
                          // maxWidth: '48vw',
                        }
                  }
                >
                  <Email
                    newConversationItem={conversationItem.newConversationItem}
                    lastInThread={idx === 0}
                    email={email}
                    contact={contact}
                  />
                  {email?.attachments?.length &&
                    email.attachments.map(attachment => (
                      <span
                        style={{
                          cursor: 'pointer',
                          textDecoration: 'underline',
                          color: 'blue',
                          marginRight: 5,
                        }}
                        onClick={() =>
                          readBlob(
                            attachment?.file_uri?.slice(23),
                            'inbox/email/a/inbound',
                          ).then(payload => {
                            const a = document.createElement('a')
                            document.body.appendChild(a)
                            a.style = 'display: none'
                            a.href = payload
                            a.download = attachment.file_name
                            a.click()
                            window.URL.revokeObjectURL(payload)
                          })
                        }
                      >
                        <AttachFile style={{ fontSize: 14 }} />{' '}
                        {attachment.file_name}
                      </span>
                    ))}
                </Grid>
              ))
            : null}
        </Grid>
      </div>
    </div>
  )
}

export default connect(
  state => ({ loaded: state.inbox.emailsLoaded }),
  dispatch => bindActionCreators({ readEmail, readBlob }, dispatch),
)(withStyles(styles)(EmailItem))
